export default "__VITE_ASSET__BCVffHST__"